// extracted by mini-css-extract-plugin
export default {"AlertProvider":"RV0IVXjI","isMobile":"mWWgz53a"};